import { faAddressCard, faCalendarCheck, faCommentDots, faEyeSlash, faKey, faScreenUsers, faShare, faUserGraduate, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FloatingBar=({selectedStudents, onAction , allowedToEdit, preventChangePassword, anyCoTeacher, isCoTeacherClass})=>
{ 
  const floatingMenu = [
    {
      id: 1,
      name: 'SendMessage',
      displayName: 'Send Message',
      tooltip: 'Send Message',
      icon: <FontAwesomeIcon icon={faCommentDots} />,
      modal: () => onAction('SendMessage', selectedStudents)
    },
    {
      id: 2,
      name: 'PrintIDCards',
      displayName: 'Print ID Cards',
      tooltip: 'Print ID Cards',
      icon: <FontAwesomeIcon icon={faAddressCard} />,
      modal: () => onAction('PrintIDCards', selectedStudents)
    },
    {
      id: 3,
      name: 'ClearPassword',
      displayName: 'Clear Password',
      tooltip: 'Clear Password',
      icon: <FontAwesomeIcon icon={faKey} />,
      modal: () => onAction('ClearPassword', selectedStudents)
    },
    {
      id: 4,
      name: 'Move',
      displayName: 'Move',
      tooltip: 'Move',
      icon: <FontAwesomeIcon icon={faScreenUsers} />,
      modal: () => onAction('Move', selectedStudents)
    },
    {
      id: 5,
      name: 'Hide',
      displayName: 'Hide',
      tooltip: 'Hide',
      icon: <FontAwesomeIcon icon={faEyeSlash} />,
      modal: () => onAction('Hide', selectedStudents)
    },
    {
      id: 6,
      name: 'TransferOwnership',
      displayName: 'Transfer Ownership',
      tooltip: 'Transfer Ownership',
      icon: <FontAwesomeIcon icon={faShare} />,
      modal: () => onAction('TransferOwnership', selectedStudents)
    },
    {
      id: 7,
      name: 'ManageCoTeacher',
      displayName: 'Manage Co-Teachers',
      tooltip: 'Manage Co-Teachers',
      icon: <FontAwesomeIcon icon={faUsers} />,
      modal: () => onAction('ManageCoTeacher')
    },
    {
      id: 8,
      name: 'AddStudents',
      displayName: 'Add Students',
      tooltip: 'Add Students',
      icon: <FontAwesomeIcon icon={faUserGraduate} />,
      modal: () => onAction('AddStudents', selectedStudents)
    },
    {
      id: 9,
      name: 'SaveGoogleCalendarLink',
      displayName: 'Save Google Calendar Link',
      tooltip: 'Save Google Calendar Link',
      icon: <FontAwesomeIcon icon={faCalendarCheck} />,
      modal: () => onAction('SaveGoogleCalendarLink')
    }
  ];

  return (
    <div>
      <div className="floating-menu-in">
        {floatingMenu.map((value, index) => (
          <OverlayTrigger
            key={`float-top-${index}`}
            placement="top"
            overlay={
              <Tooltip id={`tooltip-top-${value.id}`} className="custom-tooltip">
                {value.tooltip}
              </Tooltip>
            }>
            <button
              key={`floating-Menu-btn-${index}`}
              id={`floating-menu-${value.id}`}
              onClick={() => value.modal()}
              disabled={(!allowedToEdit && !(['SendMessage','PrintIDCards'].includes(value.name))) 
                || (value.name == 'ClearPassword'&& preventChangePassword) 
                || (value.name == 'TransferOwnership'&& (!anyCoTeacher || isCoTeacherClass))
                 || (value.name == 'ManageCoTeacher' && isCoTeacherClass)
                 || (value.name == 'ClearPassword' && !(selectedStudents?.length>0))
                 || (value.name == 'Hide' && !(selectedStudents?.length>0))
                 || (value.name == 'PrintIDCards' && !(selectedStudents?.length>0))
                 || (value.name == 'SendMessage' && !(selectedStudents?.length>0))
                 || (value.name == 'Move' && !(selectedStudents?.length>0))
              }
            >
              {value.icon}
              {value.displayName}
            </button>
          </OverlayTrigger>
        ))}
      </div>
    </div>
  );
};

FloatingBar.propTypes={
  selectedStudents : PropTypes.array.isRequired,
  onAction : PropTypes.func.isRequired,
  allowedToEdit : PropTypes.bool.isRequired,
  preventChangePassword : PropTypes.bool.isRequired,
  anyCoTeacher : PropTypes.bool.isRequired,
  isCoTeacherClass : PropTypes.bool
};

export default FloatingBar;